import React, { ReactNode } from 'react';
import { Theme, ToastOptions, ToastPosition, toast } from 'react-toastify';
import styled from 'styled-components';

interface ToastProps extends ToastOptions {
  message: string | ReactNode;
  heading?: string;
  position?: ToastPosition;
  theme?: Theme;
}
type ToastComponentProps = {
  heading?: string;
  message?: string | ReactNode;
};
const ToastMessageContainer = styled.div`
  & h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
  }
  & p {
    padding: 0.25rem 0 0;
    margin: 0;
    font-size: 14px;
  }
`;

const ToastMessageComp = ({ heading, message }: ToastComponentProps) => {
  return (
    <ToastMessageContainer>
      {heading && <h3>{heading}</h3>}
      {message && <p>{message}</p>}
    </ToastMessageContainer>
  );
};
export const ToastMsg = ({
  message,
  heading,
  position,
  theme,
  ...rest
}: ToastProps): string | number => {
  const { type = 'default' } = rest;

  return toast(<ToastMessageComp message={message} heading={heading} />, {
    position: position || 'top-center',
    autoClose: 4000,
    hideProgressBar: true,
    closeOnClick: true,
    theme: theme || 'light',
    bodyClassName: 'custom-toast-body',
    type,
    ...rest
  });
};
